import { useEffect, useState } from "react";
import { toast } from "sonner";
import API, { formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Checkbox } from "../ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";

export default function OohSendStepsDialog({ c, open, onOpenChange, onChanged }) {
  const steps = c.ai_triage?.steps || [];
  const [to, setTo] = useState(c.requester?.email || "");
  const [picked, setPicked] = useState(steps.map((_, i) => i));
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState("");
  useEffect(() => { if (open) { setTo(c.requester?.email || ""); setPicked(steps.map((_, i) => i)); setMessage(""); } }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async (send) => {
    setBusy(send ? "send" : "log");
    try {
      await API.post(`/ooh/cases/${c.id}/send-steps`, { send, to, step_indexes: picked, message });
      toast.success(send ? `Steps emailed to ${to}` : "Steps logged on the case (nothing sent)");
      onOpenChange(false);
      onChanged();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Couldn't do that"); }
    finally { setBusy(""); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="ooh-send-steps-dialog">
        <DialogHeader><DialogTitle>Send the steps to {c.requester?.name || "the requester"}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">The safety-first advice and the steps you tick are emailed in plain English. A copy is kept on the case either way, so the day team can see exactly what was advised.</p>
        <div className="space-y-2">
          <label className="text-xs font-medium">Email address</label>
          <Input value={to} onChange={(e) => setTo(e.target.value)} placeholder="name@example.com" data-testid="ooh-send-to" />
        </div>
        {steps.length > 0 && (
          <div className="space-y-1.5 max-h-48 overflow-y-auto" data-testid="ooh-send-steps-list">
            {steps.map((s, i) => (
              <label key={i} className="flex items-start gap-2 text-sm">
                <Checkbox checked={picked.includes(i)} onCheckedChange={(v) => setPicked((p) => (v ? [...p, i].sort((a, b) => a - b) : p.filter((x) => x !== i)))} data-testid={`ooh-send-step-${i}`} />
                <span>{s.title}</span>
              </label>
            ))}
          </div>
        )}
        <Textarea rows={3} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Anything extra for this caller (optional)" data-testid="ooh-send-message" />
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => submit(false)} disabled={!!busy} data-testid="ooh-send-log-only">{busy === "log" ? "Logging…" : "Call only — just log it"}</Button>
          <Button onClick={() => submit(true)} disabled={!!busy || !to} data-testid="ooh-send-confirm">{busy === "send" ? "Sending…" : "Email the steps"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
